import React, { useState } from 'react'
//import video from '../../video/Code27920.mp4'
//import video from '../../video/Line46957.mp4'
import desktopVideo from '../../video/video.mp4'
import tabletVideo from '../../video/videot.mp4'
import mobileVideo from '../../video/videom.mp4'

import bg from '../../img/bg/group.jpg';

import { osName } from 'react-device-detect';


import {
    LandingContainer,
    WaveContainer,
    VideoBg,
    LandingContent,
    LandingContentWrapper,
    LandingH1,
    LandingP,
    Wave,
    LandingBtnWrapper,
    LandingBg
   
} from './LandingElements'
import { Button } from '../ButtonElement';

const getVideoSrc = width => {
    if (width >= 1080) return desktopVideo;
    if (width >= 720) return tabletVideo;
    return mobileVideo;
  };

  const video = getVideoSrc(window.innerWidth);

const HeroSection = ({isLandscape,fixLandscape}) => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <LandingContainer id='home'>
            <LandingBg>
                <VideoBg playsInline autoPlay loop muted src={video} type="video/mp4"/>
            </LandingBg>
        <WaveContainer>
            <LandingContentWrapper>
                <LandingContent>
                    <LandingH1>
                        We are the solution in 
                        industrial machining, 
                        automation and projects.
                    </LandingH1>
                 <LandingP>
                     We will help you to improve or develop your industrial 
                     processes in the more efficient way!
                </LandingP>
                <LandingBtnWrapper>

                    <Button to="contact"
                                        smooth={true}
                                        duration={500}
                                        spy={true}
                                        exact="true"
                                        offset={-140}
                                        activeClass="active" 
                                        onMouseEnter={onHover} 
                                        onMouseLeave={onHover}
                            >
                            Contact Us
                    </Button>
                </LandingBtnWrapper>
             </LandingContent>

            </LandingContentWrapper>
         <Wave xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 250">
             <path fill="#ffffff" fillOpacity="1" d="M0,160L60,170.7C120,181,240,203,360,192C480,181,600,139,720,117.3C840,96,960,96,1080,112C1200,128,1320,160,1380,176L1440,192L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
           </Wave>
         </WaveContainer>
       </LandingContainer>
    )
}

export default HeroSection  
